var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-main',[_c('el-row',[_c('el-col',{attrs:{"span":24}})],1),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('InternalRequestByModuleMonthlyReportTable')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }